import { Link } from "react-router-dom";
import {
  ContainerOutlined,
  CreditCardOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  DollarOutlined,
  UnorderedListOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { ROLES } from "../type/roles";

const menusInit = [
  {
    label: "DS hợp đồng",
    link: "/danh-sach-hop-dong",
    key: "1",
    icon: <UnorderedListOutlined />,
    roles: [ROLES.ROLE_ADMIN, ROLES.ROLE_STAFF, ROLES.ROLE_LEADER],
  },
  {
    label: "DS hợp đồng đã tải lên",
    link: "/danh-sach-hop-dong-tai-len",
    key: "5",
    icon: <ContainerOutlined />,
    roles: [ROLES.ROLE_ADMIN],
  },
  {
    label: "QL hợp đồng",
    icon: <DatabaseOutlined />,
    link: "/ql-hop-dong",
    roles: [ROLES.ROLE_ADMIN],
    key: "3",
  },
  {
    label: "QL chi phí khóa học",
    key: "4",
    link: "/ql-chi-phi-khoa-hoc",
    icon: <DollarOutlined />,
    roles: [ROLES.ROLE_ADMIN],
  },

  {
    label: "QL tài khoản",
    key: "2",
    link: "/ql-tai-khoan",
    icon: <UsergroupAddOutlined />,
    roles: [ROLES.ROLE_ADMIN, ROLES.ROLE_LEADER],
  },
];
const siderDataInit = [];
const pushSiderData = (menusInit, siderDataInit) => {
  menusInit.forEach((menuItem) => {
    siderDataInit.push({
      key: menuItem.key,
      icon: menuItem.icon,
      label: menuItem.link ? (
        <Link className="link-menu" to={`${menuItem.link}`}>
          {menuItem.label}
        </Link>
      ) : (
        <div>{menuItem.label}</div>
      ),
    });
  });
};

pushSiderData(menusInit, siderDataInit);
export { siderDataInit, menusInit, pushSiderData };
